import { useTranslation } from "react-i18next";
import { NeedPriority } from "../../autogen/bff-api";

export const useNeedPriorityLabel = () => {
  const { t } = useTranslation();
  return (priority: NeedPriority): string => {
    switch (priority) {
      case NeedPriority.High:
        return t("High");
      case NeedPriority.Medium:
        return t("Medium");
      case NeedPriority.Low:
        return t("Low");
    }
  };
};

export const NEED_PRIORITIES: NeedPriority[] = [NeedPriority.High, NeedPriority.Medium, NeedPriority.Low];
